import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ProfileSchema } from 'pages/Splittest/profile/model/types/profileSchema';
import {
  fetchRespondentProfile,
  fetchRespondentUpdatetProfile,
} from '../services/profileService';
import NetworkError from 'shared/exceptions/network';

const initialState: ProfileSchema = {
  profile: {
    data: {},
    loading: false,
    init: false,
    updatedAt: new Date().toString(),
    update: {
      loading: false,
      smsDialogOpen: false,
    },
  },
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    onOpenSmsDialog(state) {
      state.profile.update.smsDialogOpen = true;
    },
    onCloseSmsDialog(state) {
      state.profile.update.smsDialogOpen = false;
    },
    clearUpdateError(state) {
      state.profile.update.error = undefined;
    },
  },
  extraReducers: builder => {
    //GET
    //fetchRespondentProfile
    builder
      .addCase(fetchRespondentProfile.pending, state => {
        state.profile.loading = true;
        state.profile.error = undefined;
        state.profile.update.error = undefined;
      })
      .addCase(fetchRespondentProfile.fulfilled, (state, action) => {
        state.profile.loading = false;
        state.profile.error = undefined;
        state.profile.data = action.payload.data.data;
        state.profile.updatedAt = new Date().toString();
        state.profile.init = true;
      })
      .addCase(fetchRespondentProfile.rejected, (state, action) => {
        state.profile.loading = false;
        const message = (action.payload as NetworkError).message;
        state.profile.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });

    //PUT
    //fetchRespondentUpdatetProfile
    builder
      .addCase(fetchRespondentUpdatetProfile.pending, state => {
        state.profile.update.loading = true;
        state.profile.update.error = undefined;
      })
      .addCase(fetchRespondentUpdatetProfile.fulfilled, (state, action) => {
        state.profile.update.loading = false;
        state.profile.update.error = undefined;
        state.profile.data = action.payload.data.data;
        state.profile.update.smsDialogOpen = false;
        state.profile.updatedAt = new Date().toString();
        state.profile.init = true;
      })
      .addCase(fetchRespondentUpdatetProfile.rejected, (state, action) => {
        state.profile.update.loading = false;
        const message = (action.payload as NetworkError).message;
        state.profile.update.error = {
          ...(action.payload as NetworkError),
          message,
        };
      });
  },
});
export const { actions: profileActions } = profileSlice;
export const { reducer: profileReducer } = profileSlice;
